import GradePage from "@/pages/GradePage";
export default function GradeGrade4() {
  return <GradePage grade="4" />;
}
